import React from 'react';

export const SealIcon = ({
  color = "#00A06D",
  width = 44,
  height = 44,
  "data-logo": dataLogo,
  ...props
}: {
  color?: string;
  width?: number;
  height?: number;
  "data-logo"?: string;
} & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${width}px`}
      height={`${height}px`}
      viewBox="0 0 44 44"
      fill="none"
      preserveAspectRatio="xMidYMid meet"
      data-logo={dataLogo}
      {...props}
    >
      <path
        d="M27.1576 19.5447C33.2056 18.3914 36.9184 15.0881 37.7955 10H26.6141C25.8823 11.6595 24.2734 12.5519 21.9274 12.5519C19.5813 12.5519 18.08 11.6595 17.3698 10H6.20447C7.07079 15.0881 10.7621 18.3966 16.7994 19.5447C9.83656 20.8702 6 25.0711 6 31.5473C6 32.4031 6.06457 33.2224 6.20447 34H16.7779V27.983L21.852 25.4677L27.0768 27.983V31.4429C27.0768 31.4795 27.0768 31.5108 27.0768 31.5473C27.0768 31.5786 27.0768 31.6047 27.0768 31.636V34H37.7955C37.93 33.2224 38 32.4031 38 31.5473C38 25.0711 34.1312 20.8702 27.1576 19.5447Z"
        fill={color}
      />
    </svg>
  );
};
